import React, { Component, Fragment } from 'react';
import StepWizard from 'react-step-wizard';

import Nav from './nav';
import Plugs from './plugs';

import transitions from './transitions.css';
import MicTest from '../../webrtc-validator/mictest';
import TestCase from './test_case';
import AudioTest from './audio-test';
import VideoTest from './video-test';
import CallTest from './call-test';
import PermissionsTest from "./permissions-test";
/* eslint react/prop-types: 0 */

/**
 * A basic demonstration of how to use the step wizard
 */
export default class Wizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      transitions: {
        enterRight: `animated enterRight`,
        enterLeft: `animated enterLeft`,
        exitRight: `animated exitRight`,
        exitLeft: `animated exitLeft`,
        intro: `animated intro`,
      },
      // demo: true, // uncomment to see more
    };
  }

  componentDidMount() {
    // First, we fetch the TURN configuration
    const csrf_token = document.querySelector('meta[name=csrf-token]').content;
    fetch('/appointments/fetch_turn_configuration', {
      headers: { "Content-Type": "application/json; charset=utf-8", "X-CSRF-Token": csrf_token },
      method: 'POST',
    }).then(response => response.json())
      .then(data => this.setState({ turnConfig: data }));
  }

  setInstance = SW => this.setState({ SW })

  render() {
    const { SW, demo } = this.state;

    return (
      <div className='container test-wizard'>
        <div className={'jumbotron'}>
          <div className='row'>
            <div className={`col-12 col-sm-6 offset-sm-3 webrtc-wizard-rsw-wrapper`}>
              <StepWizard
                isHashEnabled
                transitions={this.state.transitions} // comment out this line to use default transitions
                nav={<Nav />}
                instance={this.setInstance}
                isLazyMount={true}
              >
                <PermissionsTest />
                <AudioTest />
                <VideoTest />
                <CallTest turnConfig={this.state.turnConfig} />
                <Last hashKey={'TheEnd!'} />
              </StepWizard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class Last extends Component {
  render() {
    return (
      <div className={"last-step"}>
        <div className={'text-center'}>
          <h3>Tu computador es compatible con nuestro sistema de video conferencias</h3>
          <hr />
          <i className="fa fa-check-circle" />
        </div>
      </div>
    );
  }
}
